import Vue from 'vue'
import Worker from './../workers/upload.worker.js'
import uniqid from 'uniqid'

export default {
  namespaced: true,
  state: {
    items: [],
    allItems: [],
    labels: [],
    zones: [],
    selectedLabel: localStorage.getItem('label') || null,
    selectedZona: localStorage.getItem('zona') || null,
    page: Number(localStorage.getItem('page')) || 1,
    totalPages: 0,
    perPage: Number(localStorage.getItem('perPage')) || 10,
    activeEntity: null,
    search: localStorage.getItem('search') || null,
    done: Number(localStorage.getItem('done')) || null,
    _2005: Number(localStorage.getItem('_2005')) || null,
    edited: Number(localStorage.getItem('edited')) || null,
    photos: Number(localStorage.getItem('photos')) || null,
    pdfs: Number(localStorage.getItem('pdfs')) || null,
    total: 0,
    files: {
      refs: [],
      total: 0,
      count: 0,
      done: 0,
      remaining: 0
    },
    worker: null,
    workerStop: true,
    progressOne: 0,
    dataInceput: localStorage.getItem('datainceput') || null,
    dataSfarsit: localStorage.getItem('datasfarsit') || null,
    selectedUsernames: localStorage.getItem('usernames') ? [...JSON.parse(localStorage.getItem('usernames'))] : [],
    dbusernames: [],
    myEntities: localStorage.getItem('myEntities') || 'all',
    grouping: localStorage.getItem('grouping') || 'true',
    showLabels: localStorage.getItem('showLabels') || 'false',
    iconScale: Number(localStorage.getItem('iconScale')) || 1,
    objectsOnMap: localStorage.getItem('objectsOnMap') || 'users_and_markers',
    repozare: Number(localStorage.getItem('repozare')) || null
  },
  getters: {
    items: state => state.items,
    allItems: state => state.allItems,
    labels: state => state.labels,
    zones: state => state.zones,
    selectedLabel: state => state.selectedLabel,
    selectedZona: state => state.selectedZona,
    total: state => state.total,
    page: state => state.page,
    totalPages: state => state.totalPages,
    perPage: state => state.perPage,
    activeEntity: state => state.activeEntity,
    search: state => state.search,
    done: state => state.done,
    _2005: state => state._2005,
    edited: state => state.edited,
    photos: state => state.photos,
    pdfs: state => state.pdfs,
    files: state => state.files.refs,
    filesCount: state => state.files.count,
    filesSize: state => state.files.total,
    filesDone: state => state.files.done,
    workerStop: state => state.workerStop,
    progressOne: state => state.progressOne,
    dataInceput: state => state.dataInceput,
    dataSfarsit: state => state.dataSfarsit,
    dbusernames: state => state.dbusernames,
    selectedUsernames: state => state.selectedUsernames,
    myEntities: state => state.myEntities,
    grouping: state => state.grouping,
    showLabels: state => state.showLabels,
    iconScale: state => state.iconScale,
    objectsOnMap: state => state.objectsOnMap,

    repozare: state => state.repozare
  },
  mutations: {
    setItems (state, payload) {
      Vue.set(state, 'items', payload)
    },
    setTotal (state, payload) {
      Vue.set(state, 'total', payload)
    },
    setPage (state, payload) {
      state.page = payload
      localStorage.setItem('page', payload)
    },
    setPerPage (state, payload) {
      state.perPage = payload
      localStorage.setItem('perPage', payload)
    },
    setTotalPages (state, payload) {
      state.totalPages = payload
    },
    setActiveEntity (state, payload) {
      if (!payload) {
        state.activeEntity = null
        return
      }

      const activeEntity = payload

      if (!activeEntity.nr_lift_scara) {
        activeEntity.info_lift.push({
          observatii: null
        })
        activeEntity.info_lift.push({
          observatii: null
        })
        activeEntity.info_lift.push({
          observatii: null
        })
      }
      if (activeEntity.nr_lift_scara === 1) {
        activeEntity.info_lift.push({
          observatii: null
        })
        activeEntity.info_lift.push({
          observatii: null
        })
      }
      if (activeEntity.nr_lift_scara === 2) {
        activeEntity.info_lift.push({
          observatii: null
        })
      }
      state.activeEntity = activeEntity
    },
    saveItem (state, payload) {
      const stateIndex = state.items.findIndex(item => item._id === payload._id)
      Vue.set(state.items, stateIndex, payload)
    },
    setSearch (state, payload) {
      state.search = payload
      if (!payload) localStorage.removeItem('search', payload)
      else localStorage.setItem('search', payload)
    },
    setDone (state, payload) {
      state.done = payload
      if (!payload) localStorage.removeItem('done', payload)
      else localStorage.setItem('done', payload)
    },
    set2005 (state, payload) {
      state._2005 = payload
      if (!payload) localStorage.removeItem('_2005', payload)
      else localStorage.setItem('_2005', payload)
    },
    setEdited (state, payload) {
      state.edited = payload
      if (!payload) localStorage.removeItem('edited', payload)
      else localStorage.setItem('edited', payload)
    },
    setPhotos (state, payload) {
      state.photos = payload
      if (!payload) localStorage.removeItem('photos', payload)
      else localStorage.setItem('photos', payload)
    },
    setPdfs (state, payload) {
      state.pdfs = payload
      if (!payload) localStorage.removeItem('pdfs', payload)
      else localStorage.setItem('pdfs', payload)
    },
    addPhotoEntity (state, payload) {
      if (state.activeEntity && state.activeEntity._id === payload.entity) {
        if (payload.tip === 'photo') {
          state.activeEntity.photos.push(payload.url)
        } else {
          state.activeEntity.pdfs.push(payload.url)
        }
      }
      const entityIndex = state.items.findIndex(item => item._id === payload.entity)
      if (entityIndex > -1) {
        if (state.activeEntity && state.activeEntity._id !== state.items[entityIndex]._id) {
          if (payload.tip === 'photo') {
            state.items[entityIndex].photos.push(payload.url)
          } else {
            state.items[entityIndex].pdfs.push(payload.url)
          }
        }
      }
    },
    setFilesStats (state, payload) {
      Vue.set(state.files, 'refs', payload.files)
      Vue.set(state.files, 'total', payload.total)
      Vue.set(state.files, 'done', payload.done)
      Vue.set(state.files, 'count', payload.count)
    },
    removeFile (state, file) {
      state.worker.postMessage({ type: 'remove', key: file.key })
    },
    incrementDone (state) {
      Vue.set(state.files, 'done', state.files.done + 1)
    },
    setWorkerStop (state, payload) {
      state.workerStop = payload
    },
    setLabels (state, payload) {
      Vue.set(state, 'labels', payload)
    },
    setZones (state, payload) {
      Vue.set(state, 'zones', payload)
    },
    setSelectedLabel (state, payload) {
      state.selectedLabel = payload
      if (!payload) localStorage.removeItem('label', payload)
      else localStorage.setItem('label', payload)
    },
    setSelectedZona (state, payload) {
      state.selectedZona = payload
      if (!payload) localStorage.removeItem('zona', payload)
      else localStorage.setItem('zona', payload)
    },
    setProgressOne (state, payload) {
      state.progressOne = payload
    },
    setAllItems (state, payload) {
      Vue.set(state, 'allItems', payload)
    },
    setWorker (state, payload) {
      state.worker = payload
    },

    setDataInceput (state, payload) {
      state.dataInceput = payload
      if (!payload) localStorage.removeItem('datainceput', payload)
      else localStorage.setItem('datainceput', payload)
    },
    setDataSfarsit (state, payload) {
      state.dataSfarsit = payload
      if (!payload) localStorage.removeItem('datasfarsit', payload)
      else localStorage.setItem('datasfarsit', payload)
    },

    setSelectedUsernames (state, payload) {
      state.selectedUsernames = [...payload]
      localStorage.setItem('usernames', JSON.stringify(state.selectedUsernames))
    },

    setDBUsernames (state, payload) {
      state.dbusernames = payload.map(u => u.username)
    },
    setMyEntities (state, payload) {
      state.myEntities = payload
      localStorage.setItem('myEntities', payload)
    },
    toggleGrouping (state) {
      if (state.grouping === 'true') {
        state.grouping = 'false'
        localStorage.setItem('grouping', 'false')
      } else {
        state.grouping = 'true'
        localStorage.setItem('grouping', 'true')
      }
    },
    toggleLabels (state) {
      if (state.showLabels === 'true') {
        state.showLabels = 'false'
        localStorage.setItem('showLabels', 'false')
      } else {
        state.showLabels = 'true'
        localStorage.setItem('showLabels', 'true')
      }
    },
    setIconScale (state, payload) {
      state.iconScale = payload
      localStorage.setItem('iconScale', payload)
    },
    setObjectsOnMap (state, payload) {
      state.objectsOnMap = payload
      localStorage.setItem('objectsOnMap', payload)
    },

    setRepozare (state, payload) {
      state.repozare = payload
      if (!payload) localStorage.removeItem('repozare', payload)
      else localStorage.setItem('repozare', payload)
    }
  },
  actions: {
    uploadXLSX ({ rootState }, payload) {
      return rootState.services.xlsx.create(payload)
    },

    async fetchLabels ({ rootState, commit }) {
      // console.log('fetch Label')
      const labels = await rootState.services.entities.find({ query: { $labels: true } })
      commit('setLabels', labels)
    },

    async fetchZones ({ rootState, commit }) {
      // console.log('fetch Zones')
      const zones = await rootState.services.entities.find({ query: { $zones: true } })
      commit('setZones', [...zones])
    },

    async fetchEntities ({ commit, dispatch, rootState, state }) {
      // console.log('fetch entities')   // commit('setLoading', true, { root: true })

      await dispatch('fetchLabels')
      await dispatch('fetchZones')

      const query = {
        $limit: state.perPage,
        $skip: state.perPage * (state.page - 1),
        $sort: {
          simbol: 1
        }
      }

      if (state.search) {
        query.$search = state.search
      }

      if (state.done !== null) {
        query.done = state.done === 1
      }

      if (state._2005 !== null) {
        query.constructie_dupa_2005 = state._2005 === 1
      }

      if (state.myEntities !== 'all') {
        if (state.myEntities === 'mine') {
          query.user = rootState.auth.user.username
        } else {
          query.user = null
        }
      }

      if (state.edited !== null) {
        if (state.edited === 1 || state.edited === '1') {
          query.user = { $ne: null }
        } else {
          query.user = null
        }
      }

      if (state.repozare !== null) {
        if (state.repozare === 1) {
          query.repozare = 'Da'
        } else if (state.repozare === -1) {
          query.repozare = 'Nu'
        }
      }

      if (state.photos !== null) {
        query.photos = state.photos === 1 ? { $ne: [] } : []
      }

      if (state.pdfs !== null) {
        query.pdfs = state.pdfs === 1 ? { $ne: [] } : []
      }

      if (state.selectedLabel) {
        query.eticheta = state.selectedLabel
      }

      if (state.selectedZona) {
        query.zona = state.selectedZona
      }

      if (state.dataInceput && state.dataSfarsit) {
        const [yeardi, monthdi, daydi] = state.dataInceput.split('-')
        const [yeards, monthds, dayds] = state.dataSfarsit.split('-')

        query.$and = [
          { updatedAt: { $gte: new Date(Date.UTC(yeardi, monthdi - 1, daydi, 0, 0, 0)) } },
          { updatedAt: { $lte: new Date(Date.UTC(yeards, monthds - 1, dayds, 23, 59, 59)) } }
        ]
      } else {
        if (state.dataInceput) {
          const [year, month, day] = state.dataInceput.split('-')
          query.updatedAt = {
            $gte: new Date(Date.UTC(year, month - 1, day, 0, 0, 0))
          }
        }

        if (state.dataSfarsit) {
          const [year, month, day] = state.dataSfarsit.split('-')
          query.updatedAt = {
            $lte: new Date(Date.UTC(year, month - 1, day, 23, 59, 59))
          }
        }
      }

      if (state.selectedUsernames.length) {
        query.user = { $in: state.selectedUsernames }
      }

      // console.log(query)

      rootState.services.entities.find({ query }).then(result => {
        commit('setTotalPages', Math.ceil(result.total / state.perPage))
        commit('setItems', result.data)
        commit('setTotal', result.total)
        dispatch('fetchAllEntities')
        // if (state.activeEntity) {
        //   const newActiveEntity = result.data.find(item => item._id === state.activeEntity._id)
        //   if (newActiveEntity) {
        //     commit('setActiveEntity', newActiveEntity)
        //   }
        // }
        // commit('setLoading', false, { root: true })
        commit('resetRefreshCount', false, { root: true })
      }).catch(err => {
        commit(
          'saveMessage',
          {
            id: uniqid(),
            text: err.message || err.error.message,
            timestamp: new Date(),
            tip: 'error',
            type: 'fail'
          },
          { root: true }
        )
        console.log(err)
        // commit('setLoading', false, { root: true })
      })
    },
    async fetchAllEntities ({ rootState, state, commit }) {
      // console.log('fetch all entities')
      const query = {
        $paginate: false,
        $sort: {
          simbol: 1
        }
      }

      if (state._2005 !== null) {
        query.constructie_dupa_2005 = state._2005 === 1
      }

      if (state.dataInceput && state.dataSfarsit) {
        const [yeardi, monthdi, daydi] = state.dataInceput.split('-')
        const [yeards, monthds, dayds] = state.dataSfarsit.split('-')

        query.$and = [
          { updatedAt: { $gte: new Date(Date.UTC(yeardi, monthdi - 1, daydi, 0, 0, 0)) } },
          { updatedAt: { $lte: new Date(Date.UTC(yeards, monthds - 1, dayds, 23, 59, 59)) } }
        ]
      } else {
        if (state.dataInceput) {
          const [year, month, day] = state.dataInceput.split('-')
          query.updatedAt = {
            $gte: new Date(Date.UTC(year, month - 1, day, 0, 0, 0))
          }
        }

        if (state.dataSfarsit) {
          const [year, month, day] = state.dataSfarsit.split('-')
          query.updatedAt = {
            $lte: new Date(Date.UTC(year, month - 1, day, 23, 59, 59))
          }
        }
      }

      if (state.selectedLabel) {
        query.eticheta = state.selectedLabel
      }

      if (state.selectedZona) {
        query.zona = state.selectedZona
      }

      if (state.done !== null) {
        query.done = state.done === 1
      }

      if (state.edited !== null) {
        if (state.edited === 1 || state.edited === '1') {
          query.user = { $ne: null }
        } else {
          query.user = null
        }
      }

      if (state.photos !== null) {
        query.photos = state.photos === 1 ? { $ne: [] } : []
      }
      if (state.repozare !== null) {
        if (state.repozare === 1) {
          query.repozare = 'Da'
        } else if (state.repozare === -1) {
          query.repozare = 'Nu'
        }
      }
      if (state.pdfs !== null) {
        query.pdfs = state.pdfs === 1 ? { $ne: [] } : []
      }

      if (state.repozare !== null) {
        if (state.repozare === 1) {
          query.repozare = 'Da'
        } else if (state.repozare === -1) {
          query.repozare = 'Nu'
        }
      }

      if (state.myEntities !== 'all') {
        if (state.myEntities === 'mine') {
          query.user = rootState.auth.user.username
        } else {
          query.user = null
        }
      }

      if (state.selectedUsernames.length) {
        query.user = { $in: state.selectedUsernames }
      }

      try {
        const allEntities = await rootState.services.entities.find({ query })
        commit('setAllItems', allEntities)
      } catch (err) {

      }
    },

    search ({ commit, dispatch }, payload) {
      // console.log('entities search')
      commit('setSearch', payload)
      dispatch('setPage', 1)
      dispatch('fetchEntities')
    },
    setPage ({ commit, dispatch }, payload) {
      // console.log('entities set page')
      // commit('setLoading', true, { root: true })
      commit('setPage', payload)
      // commit('setLoading', false, { root: true })

      dispatch('fetchEntities')
    },
    setPerPage ({ commit, dispatch }, payload) {
      // console.log('entities set per page')
      // commit('setLoading', true, { root: true })
      commit('setPerPage', payload)
      // commit('setLoading', false, { root: true })
      dispatch('setPage', 1)
      dispatch('fetchEntities')
    },
    setActiveEntity ({ state, rootState, commit }, payload) {
      if (payload || state.activeEntity) {
        const entityId = payload || state.activeEntity._id
        // commit('setLoading', true, { root: true })

        rootState.services.entities.get(entityId).then(result => {
          commit('setActiveEntity', result)
          // commit('setLoading', false, { root: true })
        }).catch(err => {
          console.log(err)
          commit(
            'saveMessage',
            {
              id: uniqid(),
              text: err.message || err.error.message,
              timestamp: new Date(),
              tip: 'error',
              type: 'fail'
            },
            { root: true }
          )
          // commit('setLoading', false, { root: true })
        })

        // commit('setLoading', false, { root: true })
      }
    },
    save ({ commit, rootState, state }, payload) {
      // commit('setLoading', true, { root: true })

      // delete payload.createdAt
      delete payload.updatedAt

      rootState.services.entities.update(payload._id, payload).then(result => {
        if (state.activeEntity._id === result._id) {
          commit('setActiveEntity', result)
        }
        // commit('setLoading', false, { root: true })
      }).catch(err => {
        console.log(err)
        commit(
          'saveMessage',
          {
            id: uniqid(),
            text: err.message || err.error.message,
            timestamp: new Date(),
            tip: 'error',
            type: 'fail'
          },
          { root: true }
        )
        // commit('setLoading', false, { root: true })
      })

      // commit('saveItem', payload)
      // commit('setLoading', false, { root: true })
    },

    setupWorker ({ rootState, state, commit, dispatch }) {
      if (state.worker) {
        state.worker.postMessage('closeDB')
        state.worker.terminate()
      }
      commit('setWorker', new Worker())
      commit('setWorkerStop', true)

      dispatch('sendUserToWorker')
      state.worker.postMessage('init')
      state.worker.onmessage = m => {
        if (m.data.type === 'done') {
          // commit('setLoading', false, { root: true })
          commit('setWorkerStop', true)
          commit('setFilesStats', {
            files: [],
            done: 0,
            total: 0,
            count: 0
          })
          // dispatch('fetchEntities')
          commit('incrementRefreshCount', null, { root: true })
          commit('setProgressOne', 0)
        } else if (m.data.type === 'done with remaining') {
          // commit('setLoading', false, { root: true })
          commit('setWorkerStop', true)
          commit('setProgressOne', 0)
        } else if (m.data.type === 'read') {
          const result = m.data
          if (result) {
            // console.log(result)
            commit('setFilesStats', result)
          }
        } else if (m.data.type === 'uploaded-one') {
          commit('addPhotoEntity', m.data.file)
          commit('incrementDone')
          commit('saveMessage', {
            id: uniqid(),
            text: m.data.file.name,
            tip: m.data.file.tip,
            type: 'success',
            timestamp: new Date()
          }, { root: true })
          // dispatch('fetchEntities')
          commit('incrementRefreshCount', null, { root: true })
        } else if (m.data.type === 'progress-one') {
          commit('setProgressOne', m.data.progress)
        } else if (m.data.type === 'failed-one') {
          commit('saveMessage', {
            id: uniqid(),
            text: m.data.file.name + ' ' + m.data.err,
            tip: m.data.file.tip,
            type: 'fail',
            timestamp: new Date()
          }, { root: true })
          // if (!rootState.messagesOpen) {
          //   commit('setMessagesOpen', true, { root: true })
          // }
        } else if (m.data.type === 'uploaded-test') {
          commit('saveMessage', {
            id: uniqid(),
            text: m.data.file.name,
            tip: m.data.file.tip,
            type: 'success',
            timestamp: new Date()
          }, { root: true })
          if (!rootState.messagesOpen) {
            commit('setMessagesOpen', true, { root: true })
          }
        } else if (m.data.type === 'failed-test') {
          commit('saveMessage', {
            id: uniqid(),
            text: m.data.file.name,
            tip: m.data.file.tip,
            type: 'fail',
            timestamp: new Date()
          }, { root: true })
          if (!rootState.messagesOpen) {
            commit('setMessagesOpen', true, { root: true })
          }
        } else if (m.data.type === 'worker-error') {
          commit('saveMessage', {
            id: uniqid(),
            text: m.data.error,
            tip: 'error',
            type: 'error',
            timestamp: new Date()
          }, { root: true })
          if (!rootState.messagesOpen) {
            commit('setMessagesOpen', true, { root: true })
          }
        }
      }
      state.worker.onerror = e => {
        commit('saveMessage', {
          id: uniqid(),
          text: 'Worker error...' + JSON.stringify(e),
          tip: 'error',
          type: 'error',
          timestamp: new Date()
        }, { root: true })
        if (!rootState.messagesOpen) {
          commit('setMessagesOpen', true, { root: true })
        }
      }
    },
    sendUserToWorker ({ rootState, state }) {
      state.worker.postMessage({ type: 'setUserAndToken', token: rootState.auth.token, user: rootState.auth.user._id })
    },
    addFiles ({ state, rootState, commit, dispatch }, payload) {
      // dispatch('setOnlineOfflineHandler', null, { root: true })

      const files = payload.files.map((f, i) => {
        return {
          ref: f,
          entity: payload.entity,
          tip: payload.tip,
          parent: payload.parent,
          idObiectiv: payload.idObiectiv
        }
      })

      state.worker.postMessage({ type: 'add', files })
    },
    async deletePhotos ({ dispatch, commit, rootState }, payload) {
      if (payload.photos.length) {
        // commit('setLoading', true, { root: true })
        // payload.entity -> entity._id
        // payload.photos -> array of urls; /photos/entityid_userid_timestamp.extension
        for (let photo of payload.photos) {
          try {
            await rootState.services.photos.remove(null, {
              query: {
                url: photo
              }
            })
          } catch (err) {
            commit(
              'saveMessage',
              {
                id: uniqid(),
                text: err.message || err.error.message,
                timestamp: new Date(),
                tip: 'error',
                type: 'fail'
              },
              { root: true }
            )
          }
        }

        if (payload.entity) {
          dispatch('setActiveEntity', payload.entity)
          // commit('setLoading', false, { root: true })
        }
      }
    },

    toggleDone ({ commit, state, dispatch }) {
      // console.log('entities toggle done')
      if (state.done === null) { // all
        commit('setDone', 1)
      } else if (state.done === 1) { // done
        commit('setDone', -1)
      } else { // not done
        commit('setDone', null)
      }
      dispatch('setPage', 1)
      dispatch('fetchEntities')
    },

    toggle2005 ({ commit, state, dispatch }) {
      // console.log('entities toggle 2005')
      if (state._2005 === null) { // all
        commit('set2005', 1)
      } else if (state._2005 === 1) { // after 2005
        commit('set2005', -1)
      } else { // before 2005
        commit('set2005', null)
      }
      dispatch('setPage', 1)
      dispatch('fetchEntities')
    },

    toggleEdited ({ commit, state, dispatch }) {
      // console.log('entities toggle edited')

      if (state.edited === null) { // all
        commit('setEdited', 1)
      } else if (state.edited === 1) { // edited
        commit('setEdited', -1)
      } else { // not edited
        commit('setEdited', null)
      }
      dispatch('setPage', 1)
      dispatch('fetchEntities')
    },
    togglePhotos ({ commit, state, dispatch }) {
      // console.log('entities toggle photos')

      if (state.photos === null) { // all
        commit('setPhotos', 1)
      } else if (state.photos === 1) { // Photos
        commit('setPhotos', -1)
      } else { // no Photos
        commit('setPhotos', null)
      }
      dispatch('setPage', 1)
      dispatch('fetchEntities')
    },
    togglePdfs ({ commit, state, dispatch }) {
      // console.log('entities toggle pdfs')

      if (state.pdfs === null) { // all
        commit('setPdfs', 1)
      } else if (state.pdfs === 1) { // Pdfs
        commit('setPdfs', -1)
      } else { // no Pdfs
        commit('setPdfs', null)
      }
      dispatch('setPage', 1)
      dispatch('fetchEntities')
    },

    toggleRepozare ({ commit, state, dispatch }) {
      // console.log('entities toggle photos')

      if (state.repozare === null) { // all
        commit('setRepozare', 1)
      } else if (state.repozare === 1) { // Repozare
        commit('setRepozare', -1)
      } else { // no Repozare
        commit('setRepozare', null)
      }
      dispatch('setPage', 1)
      dispatch('fetchEntities')
    },

    uploadPhotos ({ commit, rootState, state }) {
      // commit('setLoading', true, { root: true })

      commit('setWorkerStop', false)
      state.worker.postMessage({ type: 'upload' })
    },

    pauseUpload ({ state, commit }) {
      commit('setWorkerStop', true)
      state.worker.postMessage({ type: 'stop' })
    },
    resumeUpload ({ state, commit }) {
      commit('setWorkerStop', false)
      state.worker.postMessage({ type: 'resume' })
    },

    saveEditedPhoto ({ rootState, dispatch }, payload) {
      dispatch('deletePhotos', { photos: [payload.photo] })
      return rootState.services.photos.create({
        buffer: payload.newImage,
        entity: payload.id,
        user: rootState.auth.user._id,
        parent: payload.parent
      }).then(result => {
        return rootState.services.entities.get(result.entity)
      })
      // return fetch(`${rootState.serverURL}/rest-savePhoto`, {
      //   method: 'post',
      //   headers: new Headers({
      //     'Authorization': rootState.auth.token,
      //     'Content-Type': 'application/json'
      //   }),
      //   body: JSON.stringify(payload)
      // })
    },
    async deleteEntities ({ rootState, dispatch, commit }, payload) {
      // commit('setLoading', true, { root: true })
      for (const id of payload) {
        try {
          await rootState.services.entities.remove(id)
        } catch (err) {
          commit(
            'saveMessage',
            {
              id: uniqid(),
              text: err.message || err.error.message,
              timestamp: new Date(),
              tip: 'error',
              type: 'fail'
            },
            { root: true }
          )
          console.log(err)
        }
      }
      // commit('setLoading', false, { root: true })
      // dispatch('fetchEntities')
      commit('incrementRefreshCount', null, { root: true })
    },
    async deletePdfs ({ dispatch, commit, rootState }, payload) {
      if (payload.pdfs.length) {
        // commit('setLoading', true, { root: true })
        // payload.entity -> entity._id
        // payload.photos -> array of urls; /photos/entityid_userid_timestamp.extension

        for (let pdf of payload.pdfs) {
          try {
            await rootState.services.pdfs.remove(null, {
              query: {
                url: pdf
              }
            })
          } catch (err) {
            console.log(err)
            commit(
              'saveMessage',
              {
                id: uniqid(),
                text: err.message || err.error.message,
                timestamp: new Date(),
                tip: 'error',
                type: 'fail'
              },
              { root: true }
            )
          }
        }

        if (payload.entity) {
          dispatch('setActiveEntity', payload.entity)
          // commit('setLoading', false, { root: true })
        }
      }
    },

    async badPhotos ({ rootState, commit, dispatch }, payload) {
      try {
        await rootState.services.entities.patch(payload.entity, {
          query: {
            $toggleBad: true,
            urls: payload.photos
          }
        })

        dispatch('setActiveEntity', payload.entity)
      } catch (err) {
        commit(
          'saveMessage',
          {
            id: uniqid(),
            text: err.message || err.error.message,
            timestamp: new Date(),
            tip: 'error',
            type: 'fail'
          },
          { root: true }
        )
      }
    },

    async fetchUsernames ({ rootState, commit }) {
      const users = await rootState.services.users.find({ query: { $select: ['username'], $paginate: false } })
      commit('setDBUsernames', users)
    },

    filterByUsername ({ state, commit, dispatch }, payload) {
      commit('setSelectedUsernames', payload)
      dispatch('fetchEntities')
    },

    toggleMyEntities ({ commit, state, dispatch }) {
      // console.log('entities toggle 2005')
      if (state.myEntities === 'all') { // all
        commit('setMyEntities', 'mine')
      } else if (state.myEntities === 'mine') { // just mine
        commit('setMyEntities', 'not mine')
      } else { // just mine
        commit('setMyEntities', 'all')
      }
      dispatch('setPage', 1)
      dispatch('fetchEntities')
    }
  }
}
